import { initReactI18next } from "react-i18next";
import i18n from "i18next";

import { defaultLocale } from "constants/shared";

import translations from "./translationNext";

i18n
  .use(initReactI18next) //NOTE::: passes i18n down to react-i18next
  .init({
    resources: translations,
    //TODO:::lng: "nl",
    lng: defaultLocale,
    //TODO:::fallbackLng: "nl",
    fallbackLng: defaultLocale,
    interpolation: {
      escapeValue: false, //TODO::: react already safes from xss
    },
  });
